// src/components/ui/textarea.jsx
import React from 'react';

export const Textarea = ({ 
  value,
  onChange,
  placeholder = '',
  rows = 4,
  disabled = false,
  className = '',
  id,
  name,
  required = false,
  maxLength
}) => {
  return (
    <textarea
      id={id}
      name={name}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      rows={rows}
      disabled={disabled}
      required={required}
      maxLength={maxLength}
      className={`
        w-full px-3 py-2
        border border-input rounded-md
        bg-background text-foreground
        placeholder:text-muted-foreground
        focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent
        disabled:opacity-50 disabled:cursor-not-allowed
        resize-none
        transition-colors
        ${className}
      `}
    />
  );
};

export default Textarea;